import React from 'react';
import { TranscriptSnippet, formatCallInsightsTimestamp } from './types';
import { getSpeakerLabel } from '../../config/participants';

interface TranscriptBlockProps {
  transcripts: TranscriptSnippet[];
  isExpanded: boolean;
  onToggle: () => void;
}

/**
 * Reusable collapsible transcript context block used across adherence sections.
 */
const TranscriptBlock: React.FC<TranscriptBlockProps> = ({
  transcripts,
  isExpanded,
  onToggle,
}) => {
  if (!transcripts || transcripts.length === 0) return null;

  return (
    <div className="mt-3">
      <button
        onClick={onToggle}
        className="text-sm text-blue-600 hover:text-blue-800 font-medium focus:outline-none"
        type="button"
      >
        {isExpanded ? 'Hide Transcript Context' : 'Show Transcript Context'}
        <span className="ml-1">{isExpanded ? '▲' : '▼'}</span>
      </button>
      {isExpanded && (
        <div className="mt-2 space-y-2 border-l-2 border-gray-200 pl-3">
          {transcripts.map((snippet, idx) => (
            <div key={idx} className="text-sm">
              <span
                className={`font-semibold ${
                  snippet.speaker === 'salesperson'
                    ? 'text-blue-700'
                    : 'text-purple-700'
                }`}
              >
                {getSpeakerLabel(snippet, undefined, { salespersonLabel: 'Rep' })}
              </span>
              {snippet.timestamp && (
                <span className="text-gray-400 ml-2 text-xs">
                  {formatCallInsightsTimestamp(snippet.timestamp)}
                </span>
              )}
              <p className="text-gray-700 mt-0.5">{snippet.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TranscriptBlock;
